<template>
    <div>
        <b-navbar toggleable="md" type="dark" variant="dark" fixed="top">

        <b-navbar-nav text-align="right" class="mr-5">
            <b-nav-item-dropdown :text="getAppCodeBranchStr">
            <!--b-dropdown-item 
                v-for="(application, index) in userApplications" 
                v-bind:group="application"
                v-bind:index="index"
                v-bind:key="application.id"          
                to="/application" style="font-size:13px" v-on:click="setActiveApp">{{application}}
                </b-dropdown-item-->
            <b-dropdown-item 
                v-for="(application,index) in userApplications" 
                v-bind:key="index"   
                :to="index" 
                style="font-size:13px">
                {{application}}
            </b-dropdown-item>
<!---v-on:click="setActiveApp"-->
            </b-nav-item-dropdown>

        </b-navbar-nav>



        <!--b-navbar-brand href="#">Echo/AppName</b-navbar-brand-->

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

        <b-navbar-nav v-if="activeApp==='Ops Portal Home'"  small>
            <!--b-nav-item active to="/">Ops home Link1</b-nav-item>
            <b-nav-item href="#">Ops home Link2</b-nav-item>
            <b-nav-item href="#" disabled>Ops home Link Disabled</b-nav-item-->
        </b-navbar-nav>

        <b-navbar-nav v-else-if="activeApp==='Cmdb' && userSignedIn" small>
            <!--b-nav-item active to="/">Cmdb App Link1</b-nav-item>
            <b-nav-item href="#">Cmdb App Link2</b-nav-item>
            <b-nav-item href="#" disabled>Cmdb Link Disabled</b-nav-item-->
        </b-navbar-nav>

        <b-navbar-nav v-else-if="activeApp==='IP Manager' && userSignedIn" text-align="right" class="mr-5" small>
            <b-nav-item-dropdown text="Networks" small>
                <b-dropdown-item router-link to="/ipman/search" style="font-size:13px">Search</b-dropdown-item>
                <b-dropdown-item router-link to="/ipman/browse" style="font-size:13px">Browse</b-dropdown-item>
                <b-dropdown-item router-link to="/ipman" style="font-size:13px">List</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->

        <b-navbar-nav class="ml-auto" small> 

        <b-nav-item-dropdown v-if="userSignedIn" v-bind:text="userName" right>
            <b-dropdown-item to="/profile" style="font-size:13px; padding:1px">Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-on:click="signOut" style="font-size:13px">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-text v-else right>Not Logged In</b-nav-text>

        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
    

    </div>
</template>

<script>
//import { mapGetters, mapState } from 'vuex'
import { mapGetters } from 'vuex'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

export default {
    name: 'TopNavigation',
    data() {
        return {
            code_branch: process.env.NODE_ENV
        }
    },
    props: {
        activeApp:String
    },
    computed: {
        // ...mapState({
        //     signedIn: state => state.authstore.signedIn
        // }),
        ...mapGetters('authstore', {
            user:'user',
            userSignedIn: 'userSignedIn',
            userName: 'userName',
            userApplications: 'userApplications'
        }),
        getAppCodeBranchStr(){
            if (this.code_branch!=='production'){
                return (this.activeApp + ' - '+ this.code_branch)
            } else {
                return ('')
            }
        }
    },
    methods:{
        async signOut() {
            Auth.signOut()
                .then(user => {
                    console.log(user)
                    // this.activeApp='Echo Ops Portal Home'
                    AmplifyEventBus.$emit('authState', user)
                })
                .catch(err => alert(err.message))
        },
        // setActiveApp: function (event) {
        //     this.activeApp=event.target.text.trim()
        // },
    },
}
</script>

